import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';
import Link from 'next/link';
import { YellowButton } from '@/components/button/button';
import { LoginSignupButton } from '@/components/login-signup-button/login-signup-button';
import { ExperienceFieldsFragment, ExperienceMode } from '@/generated/graphql';
import { useCurrentUser } from '@/hooks/use-current-user/use-current-user';
import { useScheduleWelcomeModalOpen } from '../hooks/use-schedule-welcome-modal-open/use-schedule-welcome-modal-open';
import { ScheduleWelcomeModal } from './schedule-welcome-modal';
import { useAuth0 } from '@/auth';
import Cookies from 'js-cookie';
import ClbcPromptModal from '@/components/clbc-prompt/clbc-prompt';

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`;
const MobileButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

type OneOnOneActionsProps = {
  experience: ExperienceFieldsFragment;
};

export const OneOnOneActions = ({ experience }: OneOnOneActionsProps) => {
  const { scheduleWelcomeModalOpen, setScheduleWelcomeModalOpen } = useScheduleWelcomeModalOpen();
  const isMobile = useMediaQuery('(max-width:768px)');
  const id = experience?.id;
  const { data: user } = useCurrentUser();
  const [clbcModalOpen, setClbcModalOpen] = useState(false);
  const { isAuthenticated } = useAuth0();

  if (!id) {
    return null;
  }
  const mode = experience?.mode;
  const welcome = !user?.welcomeVetted && mode === ExperienceMode.InPerson;
  const unavailable = !experience?.nextAvailability;
  let button: 'book' | 'welcome' | 'unavailable' = 'book';
  if (welcome) {
    button = 'welcome';
  } else if (unavailable) {
    button = 'unavailable';
  }

  const handleOpen = () => {
    if (scheduleWelcomeModalOpen === false) {
      setScheduleWelcomeModalOpen(true);
    }
  };

  // Handle booking experience using window.location.href instead of NextRouter
  const handleBookExperience = () => {
    /*if (!isAuthenticated || user?.hasRelationshipWithCLBC === undefined) {
      // If user is not authenticated or doesn't have a relationship with CLBC, show the modal
      if (!Cookies.get('clbcResponse')) {
        setClbcModalOpen(true);
      }
    } else {*/
    window.location.href = `/experiences/${id}/book/`;
    //}
  };

  const handleClbcModalClose = () => {
    setClbcModalOpen(false);
    // After user responds, navigate to the booking page
    window.location.href = `/experiences/${id}/book/`;
  };

  const content = (
    <LoginSignupButton label="Sign up to book your One-on-One">
      {button === 'book' && (
        // Replace Link with a button click that runs our handleBookExperience logic
        <YellowButton onClick={handleBookExperience}>Book Experience</YellowButton>
      )}
      {button === 'welcome' && (
        <>
          <YellowButton onClick={handleOpen}>Schedule a Welcome</YellowButton>
          <ScheduleWelcomeModal />
        </>
      )}
      {button === 'unavailable' && <YellowButton disabled>Unavailable</YellowButton>}
      <ClbcPromptModal open={clbcModalOpen} onClose={handleClbcModalClose} />
    </LoginSignupButton>
  );

  if (isMobile) {
    return <MobileButtonRow>{content}</MobileButtonRow>;
  }
  return <ButtonRow>{content}</ButtonRow>;
};
